import * as actions from "../../../actions/client/report";

const initialState = {
  loading: false,
  items: [],
  pages: null,
  filter: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_CLIENTS: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_CLIENTS_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_CLIENTS_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      return {
        ...initialState
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
